"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComponentsCacheFileSchema = exports.ComponentsCacheComponentSchema = exports.ComponentsCacheFootprintSchema = exports.ComponentsCachePadSchema = exports.ComponentsCacheSymbolSchema = exports.ComponentsCacheSymbolPinSchema = exports.ComponentsCacheSignalSchema = exports.COMPONENTS_CACHE_SCHEMA_VERSION = void 0;
const zod_1 = require("zod");
const SignalId_1 = require("./SignalId");
exports.COMPONENTS_CACHE_SCHEMA_VERSION = 1;
exports.ComponentsCacheSignalSchema = zod_1.z.object({
    id: SignalId_1.SignalIdSchema,
    name: zod_1.z.string(),
    padRefs: zod_1.z.string().array(),
    pinRefs: zod_1.z.string().nullable().array(),
});
exports.ComponentsCacheSymbolPinSchema = zod_1.z.object({
    ref: zod_1.z.string(),
    number: zod_1.z.string(),
});
exports.ComponentsCacheSymbolSchema = zod_1.z.object({
    ref: zod_1.z.string(),
    name: zod_1.z.string(),
    pins: exports.ComponentsCacheSymbolPinSchema.array(),
});
exports.ComponentsCachePadSchema = zod_1.z.object({
    ref: zod_1.z.string(),
    name: zod_1.z.string(),
});
exports.ComponentsCacheFootprintSchema = zod_1.z.object({
    ref: zod_1.z.string(),
    pads: exports.ComponentsCachePadSchema.array(),
});
exports.ComponentsCacheComponentSchema = zod_1.z.object({
    name: zod_1.z.string(),
    signals: exports.ComponentsCacheSignalSchema.array(),
    symbols: exports.ComponentsCacheSymbolSchema.array(),
    footprints: exports.ComponentsCacheFootprintSchema.array(),
});
exports.ComponentsCacheFileSchema = zod_1.z.object({
    projectModelId: zod_1.z.string(),
    schemaVersion: zod_1.z.literal(exports.COMPONENTS_CACHE_SCHEMA_VERSION),
    generatedAt: zod_1.z.string(),
    components: zod_1.z.record(zod_1.z.string(), exports.ComponentsCacheComponentSchema),
});
//# sourceMappingURL=ComponentsCacheFile.js.map